import React from "react";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import { Profile } from "../../../types/types";

interface VideoUrlProps {
    member: Profile;
}

const VideoUrl: React.FC<VideoUrlProps> = ({ member }) => {
    const { t } = useTranslation('publicProfile');
    if (!member.fighter) return null;

    return (
        <div className="space-y-4 pb-8">
            <h3 className="text-base font-semibold text-gray-800 border-b pb-2 text-start">
                {t("video_url")}
            </h3>
            <div className="space-y-3">
                {member.fighter.videoUrl ? (
                    <div className="border rounded-lg p-4 bg-gray-50">
                        <div className="space-y-1">
                            <div>
                                <ReactPlayer
                                    url={member.fighter.videoUrl}
                                    controls
                                    width="100%"
                                    height="280px"
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <p className="text-gray-500 text-center py-8">
                        {t("no_video_url")}
                    </p>
                )}
            </div>
        </div>
    );
};

export default VideoUrl;
